import React from 'react';
import Toggle from 'react-bootstrap-toggle';

import ObjectDisplay from 'components/ObjectDisplay'
const Details = props => {
  const {selected, toggleMatchApproved} = props;

  return (
    <div>
      <Toggle onstyle="success" offstyle="warning" className="pull-right" active={selected.isApproved} onClick={toggleMatchApproved(selected._id)} on="Approved" off="Not Approved" />

      <h3>Match Details</h3>
      <ObjectDisplay object={props.selected}/>
    </div>
  );
};

export default Details



// WEBPACK FOOTER //
// ./src/components/matches/Details.jsx